exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-animated-text-jsx": () => import("./../../../src/pages/AnimatedText.jsx" /* webpackChunkName: "component---src-pages-animated-text-jsx" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-preview-jsx": () => import("./../../../src/pages/Preview.jsx" /* webpackChunkName: "component---src-pages-preview-jsx" */)
}

